"use client";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {DATE_FORMAT, DATE_FORMAT_DB, DATE_TIME_FORMAT, DATE_TIME_FORMAT_DB} from "@constants/date-time";
import {forwardRef, useState} from "react";
import {format as formatFns} from 'date-fns';

function range(start, stop, step = 1) {
    if (stop === undefined) {
        stop = start;
        start = 0;
    }

    const result = [];
    if (step > 0) {
        for (let i = start; i < stop; i += step) {
            result.push(i);
        }
    } else if (step < 0) {
        for (let i = start; i > stop; i += step) {
            result.push(i);
        }
    }
    return result;
}

function getYear(date) {
    return date?.getFullYear();
}

function getMonth(date) {
    return date?.getMonth();
}

const years = range(1900, getYear(new Date()) + 1, 1);

const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const ExampleCustomInput = forwardRef(
    ({
         value,
         onClick,
         inputProps,
         required
     }, ref) => (
        <>
            <input
                autoComplete="off"
                value={value}
                className={'form-control'}
                onClick={onClick}
                required={required}
                ref={ref}
                onChange={(e) => {
                }}
                {...inputProps}
            />

        </>
    ),
);

const CustomHeader = (
    {
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
    }
) => {

    return (
        <div
            style={{
                margin: 10,
                display: "flex",
                justifyContent: "center",
                gap: "5px",
                fontSize: "0.8rem"
            }}
        >
            <button type={"button"} className="btn btn-primary" onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                    style={{
                        fontSize: "0.8rem"
                    }}
            >
                <i className="fa fa-chevron-left"/>
            </button>
            <select
                className="form-control"
                value={getYear(date)}
                onChange={({target: {value}}) => changeYear(value)}

                style={{
                    fontSize: "0.8rem"
                }}
            >
                {years?.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>

            <select
                className="form-control"
                value={months[getMonth(date)]}
                onChange={({target: {value}}) =>
                    changeMonth(months.indexOf(value))
                }

                style={{
                    fontSize: "0.8rem"
                }}
            >
                {months?.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>

            <button type={"button"} className="btn btn-primary" onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                    style={{
                        fontSize: "0.8rem"
                    }}
            >
                <i className="fa fa-chevron-right"/>
            </button>
        </div>
    )
};


export default function CustomDatePickerComponent(
    {
        dateOnly = true,
        selectedDate,
        setDateTime,
        hiddenInputProps = {},
        required = true,
        inputProps = {},
        filterDate
    }
) {

    let compDate = null;

    try {

        if (selectedDate) {
            compDate = new Date(selectedDate);

            if (!compDate || isNaN(compDate)) {
                compDate = null;
            }
        }


    } catch (error) {

        compDate = null;

    }

    const getDayClassName = (date) => {
        const currentDate = new Date(selectedDate);
        const dateMonth = date.getMonth();
        const currentMonth = currentDate.getMonth();

        if (dateMonth !== currentMonth) {
            return 'text-gray'; // Apply the gray color class
        }
        return null;
    };

    const currentDate = new Date();

    return (
        <>

            <DatePicker
                renderCustomHeader={CustomHeader}
                selected={compDate}
                filterDate={filterDate}
                dayClassName={getDayClassName}
                onChange={(date) => {
                    if (date) {
                        setDateTime(
                            formatFns(date, dateOnly ? DATE_FORMAT_DB : DATE_TIME_FORMAT_DB)
                        );
                    } else {
                        setDateTime('');
                    }

                }}
                showIcon={true}
                isClearable={true}
                className="form-control"
                readOnly={false}
                required={required}
                dateFormat={dateOnly ? DATE_FORMAT : DATE_TIME_FORMAT}
                shouldCloseOnSelect={true}
                showTimeInput={!dateOnly}
                toggleCalendarOnIconClick
                customInput={<ExampleCustomInput value={selectedDate} inputProps={inputProps}/>}
            />

            <input
                type={"hidden"}
                value={selectedDate}
                {...hiddenInputProps}
                onChange={(e) => {

                }}
            />
        </>
    );
};